import axiosInstance from "@/axios";

const getProxies = () => axiosInstance.get("/api/parsing/proxy/findAll");

const getProxySettings = () =>
  axiosInstance.get("/api/parsing/settings/findAll");

const updateProxySettings = (data) =>
  axiosInstance.post("/api/parsing/settings/update", data);

const addProxy = (data) => axiosInstance.post("/api/parsing/proxy/add", data);
const deleteProxy = (id) =>
  axiosInstance.delete(`/api/parsing/proxy/delete/${id}`);

const refreshProxy = (id, source) =>
  axiosInstance.put(`/api/parsing/proxy/${id}/activate?source=${source}`);

export {
  getProxies,
  getProxySettings,
  updateProxySettings,
  addProxy,
  deleteProxy,
  refreshProxy,
};
